// extracted by mini-css-extract-plugin
module.exports = {"icon":"VideoPreview__icon___17CiO"};